/*******************************************************************************
 * Duplicate the first thing emitted from an observable so it is emitted twice.
 * Takes two optional tranformations to apply to those two emitted values.
 ******************************************************************************/

import { Observable } from 'rxjs/Observable';

export function duplicateFirst<T>(
  firstTransform?: (from: T) => T,
  secondTransform?: (from: T) => T,
): ((source: Observable<T>) => Observable<T>) {
  return (source: Observable<T>) =>
    new Observable<T>(observer => {
      let count = 0;
      return source.subscribe({
        next(x) {
          if (count++ === 0) {
            observer.next(firstTransform ? firstTransform(x) : x);
            observer.next(secondTransform ? secondTransform(x) : x);
          } else {
            observer.next(x);
          }
        },
        error(err) {
          observer.error(err);
        },
        complete() {
          observer.complete();
        },
      });
    });
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/core/operators/duplicateFirst.ts